import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=f3a2472c&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=f3a2472c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a2472c",
  null
  
)

export default component.exports